var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 17,
    viewBox: "0 0 9 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.30875 9.58997L8.74625 6.71497H5.965V4.83997C5.965 4.02747 6.34 3.27747 7.59 3.27747H8.87125V0.808716C8.87125 0.808716 7.715 0.589966 6.62125 0.589966C4.34 0.589966 2.84 1.99622 2.84 4.49622V6.71497H0.277496V9.58997H2.84V16.59H5.965V9.58997H8.30875Z",
    fill: "#2AA7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.a1f3e4f597ebd06e04849671c31dae11.svg";
export { ForwardRef as ReactComponent };